import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleAddModal, setPage, toggleEditModal, setMaxPages, setSorting, setCheckedItem, setAddEventMode } from '../../store/eventsSlice';
import {
  getHeaders,
  headerWidths,
  tabsConfig,
  buttonsConfig,
  leftSideConfig,
  rightSideConfig,
  empty
} from './eventsTableConfig.js';
import { fetchUsers } from './eventsTableService.js';
import Table from '../../components/list2/table';
import Pagination from '../../components/components/pagination/pagination.jsx';
import Menu from '../../components/menu/menu';
import Content from '../../components/content/content';
import LineWithButtons from '../../components/components/line_with_buttons/lineWithButtons.jsx';
import UniversalLineWithComponents from '../../components/components/universal_line_with_components/universalLineWithComponents.jsx';
import ApiService from '../../components/api_services/apiService';

import AddEvent from "./addEvent";

import './Events.css'

function Events() {
  const dispatch = useDispatch();
  const activeUsersTab = useSelector((state) => state.events.activeUsersTab);
  const totalPages = useSelector((state) => state.events.maxPages);
  const currentPage = useSelector((state) => state.events.currentPage);
  const role = useSelector((state) => state.events.role);
  const sortBy = useSelector((state) => state.events.sortBy);
  const sortDirection = useSelector((state) => state.events.sortDirection);
  const checkedItems = useSelector((state) => state.events.checkedItems);
  const keyword = useSelector((state) => state.events.keyword);
  const [rows, setRows] = useState([]);
  const sortArrowColorActive = '#060606';
  const sortArrowColorInactive = '#06060650';

  const searchValue  = useSelector((state) => state.events.searchValue);

  const addModalOpen = useSelector((state) => state.events.addModalOpen );
  const editModalOpen = useSelector((state) => state.events.editModalOpen );

  const handleToggleAddModal = () => {
    dispatch(toggleAddModal());
  };

  const addModalSetTrue = () => {
    dispatch(setAddEventMode(true));
  }

  useEffect(() => {
    const loadEvents = async () => {
      const tokensValid = await ApiService.checkTokenExpiration();
      if (!tokensValid) {
        return;
      }
      await fetchUsers(sortBy, sortDirection, currentPage, dispatch, setMaxPages, setRows, checkedItems, keyword);
    };
    loadEvents();
  }, [currentPage, role, sortBy, sortDirection, checkedItems, keyword]);

  const headers = getHeaders(
    sortBy,
    sortDirection,
    dispatch,
    setSorting,
    sortArrowColorActive,
    sortArrowColorInactive,
    rows,
    checkedItems,
  );

  const paginationProps = {
    reduxSelector: (state) => state.events.currentPage,
    reduxAction: setPage,
    totalPages: totalPages,
    maxVisibleButtons: 5,
  };
  
  const rightSideConfig2 = [
    {
      component: Pagination, // Komponent do wyrenderowania
      props: paginationProps, // Właściwości przekazywane do komponentu
    },
  ];

  return (
    <div>
      {(addModalOpen || editModalOpen) && <AddEvent />}
      {/*{editModalOpen && <ViewEvent />}*/}
      <Menu />
      <Content>
        <LineWithButtons tabs={tabsConfig(activeUsersTab, dispatch, () => {})} buttons={buttonsConfig(handleToggleAddModal, addModalSetTrue)} />
        <div className="table-container">
          <UniversalLineWithComponents
            leftSide={empty}
            rightSide={rightSideConfig(searchValue, dispatch)} />
          <Table
            headers={headers}
            rows={rows}
            columnWidths={headerWidths}
            idViewing={false}
            idArrayId={1}
            cellClass2='cell-actions'
            cellClass2ConditionList={[2]} />
          <UniversalLineWithComponents
            leftSide={leftSideConfig}
            rightSide={rightSideConfig2} />          
        </div>
      </Content>
    </div>
  );
}

export default Events;
